export const colors = {
    purpleColor: "#E1D5E7",
    purpleDarkColor: "#9673A6",
    tundora: "#4D4D4D",
    codGray: "#1A1A1A",
    chelseaCucumber: "#82B366",
    alabasterapprox: "#FBFBFB",
    white: "#FFFFFF",
    guardsmanRed: "#CC0000",
    success: "#D5E8D4"
}

export const deviceSizes = {
    largeTablet: "991px",
    tablet: "767px",
    mobile: "479px",
}
